module.exports = __webpack_public_path__ + "img/tres-puntos.96b739c0.svg";